import {
    isStateTreeNode,
    getSnapshot,
    IAnyType,
    Instance,
    SnapshotOut,
} from 'mobx-state-tree';
import { RuntimeAssertionError } from './error';

const assertSnapshot = <T extends IAnyType>(
    expected: SnapshotOut<T>,
    model: Instance<T> | Instance<T>[]
): void => {
    if (!isStateTreeNode(model) && Array.isArray(model)) {
        expect(model.map(x => getSnapshot(x))).toEqual(expected);
    } else {
        expect(getSnapshot(model as Instance<T>)).toEqual(expected);
    }
};

function assertPresence<T>(value: T | null | undefined): asserts value is T {
    if (value === null || value === undefined)
        throw new RuntimeAssertionError(value);
}

export { assertSnapshot, assertPresence };
